import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/external-systems/sprinklr.png'


const _withScopeId = n => (_pushScopeId("data-v-0212370a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Connect your App with a Sprinklr Connection")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_5 = {
  key: 1,
  class: "col-12 mb-3"
}
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" To install the app you need to connect to your Sprinklr account. You need to connect your Sprinklr account in the ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("External Systems")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" section of the app store. ")
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "table table-systems" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "System"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25" }),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Added"),
    /*#__PURE__*/_createElementVNode("th", null, "Expire")
  ])
], -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "system-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "system-icon"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " Sprinklr Account ", -1))
const _hoisted_16 = {
  key: 0,
  class: "info"
}
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "modal show",
  tabindex: "-1",
  style: {"display":"block"}
}
const _hoisted_23 = { class: "modal-dialog" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Remove app", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this app?")
], -1))
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt fa-fixed me-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Remove app ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.authorizeReturn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Please wait..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_link, { to: "/external-systems" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sprinklrAccounts, (system, systemIdx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: systemIdx,
                      class: _normalizeClass([_ctx.selectedAccount === system ? 'active' : '']),
                      onClick: _withModifiers(($event: any) => (_ctx.selectedAccount = system), ["stop","prevent"])
                    }, [
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(system.name) + " ", 1),
                        (system.info)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.info, (info, infoIdx) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: infoIdx }, [
                                    _createElementVNode("th", null, _toDisplayString(info.name) + ":", 1),
                                    _createElementVNode("td", null, _toDisplayString(info.value), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(system.created_at), 1),
                      _createElementVNode("td", null, _toDisplayString(system.expire_at), 1)
                    ], 10, _hoisted_13))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                disabled: !_ctx.selectedAccount,
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveApp()))
              }, " Save ", 8, _hoisted_18),
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.removeApp && _ctx.removeApp(...args)))
              }, _hoisted_21)
            ])
          ]))
    ]),
    (_ctx.removeModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeModal = false))
                })
              ]),
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeModal = false))
                }, " Close "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeAppConfirm && _ctx.removeAppConfirm(...args)))
                }, _hoisted_31)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}